import React, { useEffect, useState } from 'react';
import Navbar from '../../pages/Navbar';
import { FaEdit } from 'react-icons/fa'; 
import '../../styles/CompanyDetails.css';
import api from "../../api";
import publicApi from '../../publicApi';
import { useNavigate } from 'react-router-dom';
import { fetchUserId, fetchCompanyId, fetchUserRolePermissions } from '../../helpers/CompanyId';

const CompanyDetails = () => {
  const [company, setCompany] = useState(null);
  const [editableCompany, setEditableCompany] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState({
    logo: null,
    coi: null,
    leave_policy: null,
    pf_policy: null,
    labour_law_licence: null,
  });

  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const getUserRolePermissions = async () => {
        try {
            setLoading(true);
            const data = await fetchUserRolePermissions();
            console.log("DD:", data)
            if (data) {
                setPermissions(data || []);

            }
        } catch (err) {
            console.error('Error fetching permissions:', err);
            setError('Failed to fetch user permissions');
        } finally {
            setLoading(false);
        }
    };

    getUserRolePermissions();
}, []); 


  useEffect(() => {

    const getCompanyDetails = async () => {
      try {
        const userId = await fetchUserId(); // Fetch userId using helper function
        console.log("UID:",userId)
        if (!userId) {
          setError('User ID not found');
          return;
        }

        const companyId = await fetchCompanyId(userId); // Fetch companyId using helper function
        console.log("UUUID:",userId)

        console.log("COMID:",companyId)
        if (!companyId) {
          setError('Company ID not found');
          return;
        }

    const url = `/api/companydetails/retrieve/${companyId}/`; 
    const response = await api.get(url);

    // Use publicApi's baseURL to construct full URLs dynamically
    const baseUrl = publicApi.defaults.baseURL;

    const updatedData = {
      ...response.data,
      logo_url: response.data.logo_url ? `${baseUrl}${response.data.logo_url}` : null,
      coi_url: response.data.coi_url ? `${baseUrl}${response.data.coi_url}` : null,
      leave_policy_url: response.data.leave_policy_url ? `${baseUrl}${response.data.leave_policy_url}` : null,
      pf_policy_url: response.data.pf_policy_url ? `${baseUrl}${response.data.pf_policy_url}` : null,
      labour_law_licence_url: response.data.labour_law_licence_url ? `${baseUrl}${response.data.labour_law_licence_url}` : null,
    };

    setCompany(updatedData);
    setEditableCompany(updatedData);
    } catch (error) {

    console.error('Error fetching company details:', error);
    setError('Failed to load company details');
}
};
getCompanyDetails();
}, [navigate]);

  const handleEdit = () => {
    setIsEditing(true); // Enable editing mode
  };

  const handleCancel = () => {
    setEditableCompany(company); // Revert to original data
    setIsEditing(false); // Exit editing mode
    setFiles({
      logo: null,
      coi: null,
      leave_policy: null,
      pf_policy: null,
      labour_law_licence: null,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditableCompany((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: files[0], // Save the selected file
      }));
    }
  };


  const handleSave = async () => {
    try {
      const userId = await fetchUserId();
      if (!userId) {
        setError('User ID not found');
        return;
      }
  
      const companyId = await fetchCompanyId(userId);
      if (!companyId) {
        setError('Company ID not found');
        return;
      }
  
      // Prepare form data for the request
      const formData = new FormData();
  
      // Append non-file data
      for (const key in editableCompany) {
        if (key === 'locations') {
          // Ensure locations is sent as a JSON array string
          const locationsValue = Array.isArray(editableCompany[key])
            ? editableCompany[key]
            : editableCompany[key]?.split(',').map((location) => location.trim());
  
          formData.append(key, JSON.stringify(locationsValue)); // Send as a JSON string
        } else {
          formData.append(key, editableCompany[key]);
        }
      }
  
      // Append file data if files exist
      if (files.logo) formData.append('logo', files.logo);
      if (files.coi) formData.append('coi', files.coi);
      if (files.leave_policy) formData.append('leave_policy', files.leave_policy);
      if (files.pf_policy) formData.append('pf_policy', files.pf_policy);
      if (files.labour_law_licence) formData.append('labour_law_licence', files.labour_law_licence);
  
      const url1 = `/api/companydetails/update/${companyId}/`;
  
      const response = await api.put(url1, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      setCompany({
        ...response.data,
      });
      setEditableCompany(response.data);
      setIsEditing(false);
  
      // Reset files after save
      setFiles({
        logo: null,
        coi: null,
        leave_policy: null,
        pf_policy: null,
        labour_law_licence: null,
      });
    } catch (error) {
      console.error('Error updating company details:', error);
      setError('Failed to update company details');
    }
  };
  
  

  if (error) return <p>{error}</p>;
  console.log('Company data:', company); 

  return (
    <div>
      <Navbar />
      <div className="companydetails-container">
        {/* <h2 style={{ alignItems: 'center' }}>
          Company Details
          <FaEdit className="edit-icon" onClick={handleEdit} />
        </h2>         */}
        <h2 style={{ alignItems: 'center' }}>
          Company Details
          {/* Conditionally render the edit icon based on 'e-company' permission */}
          {permissions.includes('u-company') && (
            <FaEdit className="edit-icon" onClick={handleEdit} />
          )}
        </h2>

        {company ? (
          <div className="company-details">
            {/* Loop through the fields */}
            {Object.keys(company).map((key) => (
  <div className="field-container" key={key}>
    <span className="field-label">{key.replace(/_/g, ' ').toUpperCase()}:</span>
    {isEditing ? (
      <>
        {['logo_url', 'coi_url', 'leave_policy_url', 'pf_policy_url', 'labour_law_licence_url'].includes(key) ? (
          <input
            type="file"
            name={key.replace('_url', '')}
            onChange={handleFileChange}
            className="input-file"
          />
        ) : (
          <input
            type="text"
            name={key}
            value={
              key === 'locations'
                ? editableCompany[key]?.join(', ') || ''
                : editableCompany[key] || ''
            }
            onChange={handleChange}
            className="input-field"
          />
        )}
      </>
    ) : (
      <span className="field-value">
        {key === 'locations'
          ? company[key]?.join(', ')
          : ['logo_url', 'coi_url', 'leave_policy_url', 'pf_policy_url', 'labour_law_licence_url'].includes(key) && company[key] ? (
            <a href={company[key]} target="_blank" rel="noopener noreferrer">View Document</a>
          ) : (
            company[key]
          )}
      </span>
    )}
  </div>
))}

           
            {/* Conditional rendering of Save button */}
            {isEditing && (
               <div className="button-container">
                <button onClick={handleSave} className="save-button">Save</button>
                <button onClick={handleCancel} className="cancel-button">Cancel</button>
              </div>            
            )}
            
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
};

export default CompanyDetails;


